module.exports = __webpack_public_path__ + "img/swiper-img3.fe481cdd.png";